module.exports = __webpack_public_path__ + "media/images/board-of-directors-f26e738250ec63868d053fd36b900cab.jpg";